import { Routes, Route } from "react-router-dom";
import emailjs from "@emailjs/browser";
import { useEffect } from "react";
import LandingPage from "./components/LandingPage";
import AdventurePackages from "./components/AdventurePackages";
import Chat from "./components/Chat";
import Admin from "./components/AdminPanel";
import Itinerary from "./components/Itenrary";
import Package from "./components/Package";
import "./App.css";

function App() {
  useEffect(() => {
    // Initialize EmailJS with your public key
    try {
      emailjs.init("wWdbz_ObusfHueH25");
    } catch (error) {
      console.error("Error initializing EmailJS:", error);
    }
  }, []);

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/adv" element={<AdventurePackages />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/adminpanel" element={<Admin />} />
        <Route path="/packages" element={<Itinerary />} />
        <Route path="/package/:id" element={<Package />} />
      </Routes>
    </div>
  );
}

export default App;

